import React from 'react';
import SectionLabel from './SectionLabel';
import useFadeIn from '../hooks/useFadeIn';
import { education } from '../data';
import '../styles/theme.css';
    
export default function Education() {
  const fade = useFadeIn();

  return (
    <section id="education" className="section">
        <SectionLabel>Education</SectionLabel>
        <div ref={fade.ref} style={fade.style}>
            {education.map((edu) => (
              <div key={edu.id} className="exp__item">
                <div className="exp__left">
                    <div className="exp__date">{edu.date}</div>
                    <div className="exp__company">{edu.institution}</div>
                    <div className="exp__location">{edu.location}</div>
                </div>
               
               <div>
                 <div className="exp__role">{edu.degree}</div>
                    <ul className="exp__list">
                    {edu.details.map((detail, index) => (
                        <li key={index} className="exp__bullet">{detail}</li>
                    ))}
                    </ul>
                </div>
              </div>
            ))}

        </div>
    </section>
  );
}